define('common/views/alert_view',['require','exports','module','base/view','ldsh!../templates/checking_urls_error','ldsh!../templates/alert_view'],function (require, exports, module) {
  'use strict';
  const BaseView = require('base/view');

  module.exports = BaseView.extend(
    {
      template: null,
      className: 'ed-alert hidden',
      hideDelay: 5000,

      events: {
        click: 'conditionalHide',
        'click .ed-close-alert': 'hide',
        'click .ed-show-description': 'toggleDescription',
      },

      initialize: function (options) {
        (this.template = this.getTemplate(options)),
          (this.alertType = options.alertType || 'success');
        this.autoHide = options.autoHide !== undefined ? options.autoHide : true;
        this.onHide = options.onHide;
        this.persist = options.persist;
        this.model = new Backbone.Model();
        this.model.set('message', options.message || '');
        this.model.set('escapeMessage', options.escapeMessage === false ? false : true);

        if (this.alertType === 'success' || this.alertType === 'info') {
          this.model.set('success', true);
        }

        if (this.alertType === 'danger') {
          this.model.set('success', false);
        }

        this.model.set('autoHide', this.autoHide);
        this.model.set('persist', this.persist);
      },

      toggleDescription: function () {
        this.$el.find('.ed-alert-description').toggle();
      },

      getTemplate: function (options) {
        if (options.templateExtended) {
          return require('ldsh!../templates/checking_urls_error');
        }
        return require('ldsh!../templates/alert_view');
      },

      conditionalHide: function (e) {
        if (!this.autoHide) {
          return true;
        }

        this.hide(e);
      },

      hide: function (e) {
        if (e) {
          e.preventDefault();
        }

        const self = this;

        this.onHide && this.onHide(e);
        self.$el.addClass('hidden');

        setTimeout(function () {
          self.remove();
        }, 1000);
      },

      onRender: function () {
        const self = this;
        this.$el.addClass('ed-alert-' + this.alertType);
        this.$el.i18n();

        if (this.autoHide) {
          setTimeout(function () {
            self.hide();
          }, this.hideDelay);
        }
      },
    },
    //static methods
    {
      /*
      - alertType is one of
        'success'
        'info'
        'warning'
        'danger'

      - message is just the content to display
      - autoHide (default-true) hides the message after 3 seconds
      */
      showAlert: function (options) {
        const alert = new module.exports(options);

        $('body').append(alert.render().$el);

        //start animation
        setTimeout(function () {
          alert.$el.removeClass('hidden');
        }, 200);

        return alert;
      },
    }
  );
});

